import React from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { PopoverWrapperProps } from "./types";
import { cn } from "@/utils/utils";
import { getPopoverBackgroundStyle } from "@/utils/popoverStyles";

interface Props extends PopoverWrapperProps {
  triggerContent: React.ReactNode;
  tooltipText: string;
  popoverContent: React.ReactNode;
  useButtonWrapper?: boolean;
  borderClassName?: string;
  showBackgroundGradient?: boolean;
  containerClassName?: string;
}

const PopoverWrapper: React.FC<Props> = ({
  isPopoverOpen,
  setIsPopoverOpen,
  triggerContent,
  tooltipText,
  popoverContent,
  useButtonWrapper = true,
  borderClassName,
  showBackgroundGradient = true,
  containerClassName
}) => {
  return (
    <Popover
      open={isPopoverOpen}
      onOpenChange={(open) => setIsPopoverOpen(open)}
    >
      <PopoverTrigger asChild>
        {useButtonWrapper ? (
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
            className="border-[0.5px] border-border-border1 rounded-[10px] p-[1.3px] h-7"
          >
            <Button
              tooltipText={tooltipText}
              variant="tertiary"
              size="icon"
              selected={isPopoverOpen}
              className="p-[0.5px]"
            >
              {triggerContent}
            </Button>
          </div>
        ) : (
          // A native button, so the trigger is reachable and opens from the keyboard.
          <button
            type="button"
            aria-label={tooltipText}
            onClick={(e) => {
              e.stopPropagation();
            }}
            className="block appearance-none bg-transparent p-0 border-0 text-left cursor-pointer rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-field-focus"
          >
            {triggerContent}
          </button>
        )}
      </PopoverTrigger>
      <PopoverContent
        padding={16}
        className={cn(
          "w-[25rem] rounded-xl flex flex-col gap-4",
          borderClassName,
          containerClassName
        )}
        align="start"
        side="right"
        onEscapeKeyDown={() => setIsPopoverOpen(false)}
        sideOffset={4}
        onClick={(e) => e.stopPropagation()}
        style={getPopoverBackgroundStyle(
          !!borderClassName,
          showBackgroundGradient
        )}
      >
        {popoverContent}
      </PopoverContent>
    </Popover>
  );
};

export default PopoverWrapper;
